import { useRenameDim } from "../../hooks/manageCubes/useRenameDim";
import { renameDimValueError } from "./dimensionValueValidation";
import { DimMappingOperationForm } from "./DimMappingOperationForm";
import { intakeScopeWarning } from "./intakeScopeWarning";

/** Props for the Rename Dimension operation form. */
interface RenameOperationProps {
  /** The target cube ID to rename dimension values in. */
  cubeId: string;
}

export function RenameOperation({ cubeId }: RenameOperationProps) {
  const renameDim = useRenameDim();

  return (
    <DimMappingOperationForm
      cubeId={cubeId}
      mutation={renameDim}
      actionText="Rename"
      dialogTitle="Rename Dimension"
      dialogBody="Rename the following dimensions. The old values will be deleted. This operation is irreversible."
      mappingListTitle="Renames:"
      mappingHint="Edit the pre-filled value(s) to rename each target dimension."
      fieldLabel={(dimLabel) => `Rename ${dimLabel}`}
      fieldPlaceholder={(dimLabel) => `Enter new ${dimLabel.toLowerCase()}`}
      editPromptError="Edit at least one pre-filled value to rename it."
      validateValue={renameDimValueError}
      dialogWarning={intakeScopeWarning}
    />
  );
}
